// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y8-1","newExpiryDate":"styles_newExpiryDate__2iXen","footer":"styles_footer__2pTCU"};